module.exports = __webpack_public_path__ + "static/img/top three winners.f3e368f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/top three winners.jpg
// module id = hvsS
// module chunks = 1